import React, { useState, useEffect } from "react";
import {
  Card,
  Grid,
  Paper,
  Typography,
  withStyles,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Skeleton from "@material-ui/lab/Skeleton";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { connect } from "react-redux";
import { appService } from "../../App/app.service";
import {
  customDateFormatter,
  getUniqueValues,
} from "../../util/customFunctions";
import ErrorBoundary from "../../components/ErrorBoundary";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";
import TeamFilterHierarchy from "../../components/team-filter-hirarchy";
import PipelineSufficiencySection from "./PipelineSufficiencySection";
import AssumptionsSection from "./Assumptionssection";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import DrilldownBody from "../../components/Drilldown/DrilldownWithSLD";
import ExpectedAcvPage from "../../EnhancedInsights/NewWaterFall/ExpectedAcvPage";
import TeamFilterHierarchySingleSelect from "../../components/TeamHirerachySingleSelect";

// Custom Tooltip
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "15rem",
    fontSize: "1rem",
    color: "black",
    textAlign: "center",
    background: "white",
    border: "0.5px solid lightgrey",
  },
});

// Styles
const styles = (theme) => ({
  root: {},
  content: {},
  buttons: {
    display: "flex",
    justifyContent: "center",
    "& > *": {
      marginLeft: theme.spacing(1),
    },
  },
  table: {
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    color: "inherit",
  },
  tableClickable: {
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    color: "inherit",
    cursor: "pointer",
  },
  rep: {
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    width: "20%",
    color: "inherit",
  },
  tableHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    color: "inherit",
  },
  repHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "2px 10px",
    width: "20%",
    color: "inherit",
  },
  mainTable: {
    width: "100%",
    maxWidth: "100%",
    [theme.breakpoints.up(1250)]: {
      width: 1000,
    },
    [theme.breakpoints.up(1900)]: {
      width: 1400,
    },
  },
  mainTable2: {
    width: "100%",
    maxWidth: "100%",
    [theme.breakpoints.up(1250)]: {
      width: 800,
    },
    [theme.breakpoints.up(1900)]: {
      width: 1200,
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});

const PSCA = (props) => {
  const [state, setState] = useState({
    location: null,
    secondLevelLocation: null,
    toggleValue: "Current_acv",
    tab: "Summary",
    num: 2,
    filtersForChild: [],
    filtersForDrilldown: [],
    heading: "",
    drilldownLabelString: "",
    isMetaData: false,
    metaData: null,
    loading: false,
    rep: ["All"],
    team: ["All"],
    activeFilters: [],
    Look_Ahead_Qtr: 4
  });

  // Fetch filters on component mount
  useEffect(() => {
    props.getFunnelFilters();
  }, []);

  // Set default filters and fetch data when filters arrive
  useEffect(() => {
    if (props.funnelFilters && props.funnelFilters !== "") {
      // Get default team from filters
      const defaultTeam = props.funnelFilters?.parentChildrenTeamFilter
        ?.defaultValueTeam || ["All"];

        const deafaultLookAheadQtr = props.funnelFilters?.defaultLook_Ahead_Qtr || 4
      
      // Set default values
      setState((prev) => ({
        ...prev,
        team: defaultTeam,
        rep: ["All"], // Rep is always All by default
        Look_Ahead_Qtr: deafaultLookAheadQtr
      }));

      // Build initial filters
      let filters = [];
      let assumptionsFilters = []
      
      // Add default team filter if not "All"
      if (!defaultTeam.includes("All")) {
        const teamNames = defaultTeam.map(
          (s) =>
            props.funnelFilters.teams.filter((r) => r.Display_Name === s)[0]
              ?.Display_Name
        ).filter(Boolean);
        
        if (teamNames.length > 0) {
          filters.push({ name: "team", value: teamNames });
        }
      }

      filters.push({name: 'Look_Ahead_Qtr', value: deafaultLookAheadQtr})

      // Fetch data with default filters based on active tab
      setState((prev) => ({ ...prev, loading: true, activeFilters: filters }));
      
      if (state.tab === "Summary") {
        props.getNewQualifiedPipelineData(filters);
      } else if (state.tab === "Assumptions") {
        props.getPipelineMixAnalysisDatav2(assumptionsFilters);
      }
    }
  }, [props.funnelFilters]);

  // Component mount and tab change handler
  useEffect(() => {
    // Skip if filters haven't loaded yet
    if (!props.funnelFilters || props.funnelFilters === "") {
      return;
    }

    // Use active filters when changing tabs
    const filters = state.activeFilters;
    const assumptionsFilters = []

    if (state.tab === "Summary") {
      setState((prev) => ({ ...prev, loading: true }));
      props.getNewQualifiedPipelineData(filters);
    } else if (state.tab === "Assumptions") {
      setState((prev) => ({ ...prev, loading: true }));
      props.getPipelineMixAnalysisDatav2(assumptionsFilters);
    }
  }, [state.tab]);

  // Update loading state when data arrives
  useEffect(() => {
    if (props.NewQualifiedPipelineData !== "") {
      setState((prev) => ({ ...prev, loading: false }));
    }
  }, [props.NewQualifiedPipelineData]);

  useEffect(() => {
    if (props.AssumptionsData !== "") {
      setState((prev) => ({ ...prev, loading: false }));
    }
  }, [props.AssumptionsData]);

  // Event handlers
  const handleChangeTab = (e, newValue) => {
    if (newValue !== null) {
      console.log("Tab changed to:", newValue);
      setState({
        ...state,
        tab: newValue,
      });
    }
  };


  const handleChangeToggle = (e) => {
    setState({
      ...state,
      toggleValue: e.target.value,
    });
  };

  const handleChangeLocationBack = (location) => {
    setState({
      ...state,
      location: location,
      secondLevelLocation: location,
    });
  };

 const handleChangeLocation = (location, values, type, qtr) => {
    if (location !== "overview") {
      let filters = [...state.activeFilters, {name: 'isDrillDown', value: true}];
      let drildownFilters = [];

if(values.length > 0){
  filters = [...filters, {name: type, value: values}]
  let title = type
  if(type === 'Lead_Source'){
    title= 'Lead Source'
  }
    if(type === 'Cust_Type'){
    title= 'Cust Type'
  }
  drildownFilters = [{title: title, value: values}]
}
    
if(qtr.length > 0){
  filters = [...filters, {name: 'projected_close_fiscal_quarter', value: qtr}]
  drildownFilters = [...drildownFilters, {title: 'Projected Close Date', value: qtr}]
}

if(state.team[0] !== 'All'){
  drildownFilters = [...drildownFilters, {title: 'Team', value: state.team}]
}

if(state.rep[0] !== 'All'){
  const r = props.funnelFilters.reps.filter(f => state.rep.includes(f.UserID)).map(f => f.Full_Name)
  drildownFilters = [...drildownFilters, {title: 'Rep', value: r}]
}



    

      setState({
        ...state,
        location: location,
        secondLevelLocation: location,
        // header:key1 === 'Won' ? 'Won' : key1 === 'Open' ? `Open Pipeline (${this.state.Stage[0]} or later)` : `Lost or Disqualified (${this.state.Stage[0]} or later)`,
        filtersForDrilldown: [...drildownFilters],
      });

     

        props.getContactDrilldownData(filters);
      
    } else {
      props.clearDrilldownData();
    }
  };
  const handleSecondLevelDrilldown = (location, oppId) => {
    console.log(oppId);
    setState({
      ...state,
      secondLevelLocation: location,
    });
    props.getOpenOppData(oppId);
  };

  const stepBack = () => {
    setState({
      ...state,
      secondLevelLocation: "",
    });
    props.clearExpectedAcvData();
  };

  // Filter handlers
  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]:
        e.target.value.length === 0
          ? ["All"]
          : state[e.target.name].length === 1 && state[e.target.name].includes("All")
          ? e.target.value.filter((v) => v !== "All").length > 0
            ? e.target.value.filter((v) => v !== "All")
            : ["All"]
          : e.target.value.includes("All")
          ? ["All"]
          : e.target.value,
    });
  };

  const handleChangeTeam = (fValues) => {
    const filteredValues = typeof fValues === 'string' ? [fValues] : fValues
    setState({
      ...state,
      team:
        state.team.length === 1 && state.team.includes("All")
          ? filteredValues.filter((v) => v !== "All").length > 0
            ? filteredValues.filter((v) => v !== "All")
            : ["All"]
          : filteredValues.includes("All")
          ? ["All"]
          : filteredValues,
    });
  };


  const   handleChangeOffsetDays = (e) => {
    setState({
      ...state,
      Look_Ahead_Qtr: e.target.value,
    });
  };

  const onRepChange = (event, value) => {
    setState({
      ...state,
      rep: [value ? value : "All"],
    });
  };

  const orderRepsByLastName = () => {
    if (!props.funnelFilters || !props.funnelFilters.reps) return ["All"];

    let reps = props.funnelFilters.reps
      .map((r) => r.Full_Name)
      .map((rep) => {
        const res = rep.split(" ", 2);
        return {
          firstName: res[0],
          lastName: res[1],
          fullName: rep,
          sortName: `${res[0]} ${res[1]}`,
        };
      });

    function compare(a, b) {
      if (a.sortName < b.sortName) return -1;
      if (a.sortName > b.sortName) return 1;
      return 0;
    }

    reps.sort(compare);
    reps = [
      { firstName: "All", lastName: "All", fullName: "All", sortName: "All" },
      ...reps,
    ];

    return reps.map((rep) => rep.fullName);
  };

  const handleGo = () => {
    let filters = [];
    let assumptionsFilters = []

    // Add rep filter
    if (!state.rep.includes("All") && props.funnelFilters) {
      const repIds = state.rep.map(
        (s) =>
          props.funnelFilters.reps.filter((r) => r.Full_Name === s)[0].UserID
      );
      filters.push({ name: "rep", value: repIds });
    }

    // Add team filter
    if (!state.team.includes("All") && props.funnelFilters) {
      const teamNames = state.team.map(
        (s) =>
          props.funnelFilters.teams.filter((r) => r.Display_Name === s)[0]
            .Display_Name
      );
      filters.push({ name: "team", value: teamNames });
    }

    filters.push({name: "Look_Ahead_Qtr", value: state.Look_Ahead_Qtr})

    setState((prev) => ({ ...prev, activeFilters: filters, loading: true }));

    if (state.tab === "Summary") {
      props.getNewQualifiedPipelineData(filters);
    } else if (state.tab === "Assumptions") {
      props.getPipelineMixAnalysisDatav2(assumptionsFilters);
    }
  };

  return (
    <Grid container>
      {/* Header */}
      <AddHeaderDescriptionWithHelperText
        header={`Pipeline Goal vs. Actual By Source`}
        description={`Pipeline Goal vs. Actual By Source`}
        helperTextCharts={props.helperTextCharts}
      />

      {/* Filters - Hide in Assumptions Tab */}
    {/* Filters - Hide in Assumptions Tab */}
{state.tab !== "Assumptions" && (
  <>
    {props.funnelFilters !== "" ? (
      <>
        {/* Rep & Team Filters */}
        <Grid
          container
          item
          style={{ padding: 10, paddingTop: 15 }}
          xs={6}
          md={4}
        >
          <Grid item spacing={2} xs={12} container component={Paper}>
            <Grid item xs={12} sm={6}>
              <TeamFilterHierarchySingleSelect
                label="Team:"
                value={state.team}
                data={
                  props.funnelFilters?.parentChildrenTeamFilter
                    ?.filters || []
                }
                onTeamChange={handleChangeTeam}
                name="team"
                disabled={!state.rep.includes("All")}
                labelColorCondition={!state.team.includes("All")}
                renderValue={(selected) => selected.join(", ")}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) =>
                  option.parentValue + option.label
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="combo-box-rep"
                options={orderRepsByLastName()}
                getOptionLabel={(option) => option}
                value={state.rep[0]}
                onChange={onRepChange}
                name="rep"
                data-test="Rep"
                disabled={!state.team.includes("All")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Rep:"
                    variant="standard"
                    InputLabelProps={{
                      style: {
                        color: !state.rep.includes("All")
                          ? "#4472c4"
                          : "#000",
                      },
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>


         <Grid
          container
          item
          style={{ padding: 10, paddingTop: 15 }}
          xs={4}
          md={2}
        >
          <Grid item spacing={2} xs={12} container component={Paper}>
       
            <Grid item xs={12}>
                 <FormControl fullWidth className={styles.formControl}>
                    <InputLabel
                      id="select-Look_Ahead_Qtr-label"
                      style={{ color: "#4472c4" }}
                    >
                      Look Ahead Qtrs.:
                    </InputLabel>
                  
                      <Select
                        data-test="Look_Ahead_Qtr"
                        labelId="sLook_Ahead_Qtr-label"
                        id="Look_Ahead_Qtr"
                        value={state.Look_Ahead_Qtr}
                        onChange={handleChangeOffsetDays}
                        label="Look Ahead Qtrs."
                        name="Look_Ahead_Qtr"
                      >
                        {props.funnelFilters.Look_Ahead_Qtr
                          .map((x, y) => (
                            <MenuItem key={x} value={x}>
                              {x}
                            </MenuItem>
                          ))}
                      </Select>
                    
                  </FormControl>
            </Grid>
          </Grid>
        </Grid>

        {/* GO Button */}
        <Grid
          container
          item
          style={{ padding: 10, paddingTop: 15 }}
          justify="space-between"
          xs={4}
          lg={2}
        >
          <Grid item xs={4} xl={3} container justify="flex-end">
            <Button
              data-test="go"
              variant="contained"
              color="primary"
              onClick={handleGo}
            >
              GO
            </Button>
          </Grid>
        </Grid>
      </>
    ) : (
      // Loading skeleton - covers entire filter area
      <Grid
        container
        item
        style={{ padding: 10, paddingTop: 15 }}
        xs={12}
        // md={6}
      >
        <Grid item container component={Paper} justify="center">
          <Skeleton
            variant="rect"
            animation="wave"
            height={60}
            width="100%"
            style={{ margin: "10px" }}
          />
        </Grid>
      </Grid>
    )}
  </>
)}

      {/* Tab Toggle */}
      {props.funnelFilters !== "" && (
        <Grid
          item
          xs={12}
          md={12}
          id="grid-container"
          style={{ marginTop: "1rem" }}
        >
          <Paper style={{ marginBottom: "-7px" }}>
            <ToggleButtonGroup
              color="primary"
              indicatorColor="primary"
              value={state.tab}
              exclusive
              size="large"
              onChange={handleChangeTab}
            >
              <ToggleButton
                style={{
                  background: state.tab === "Summary" ? "#4472C4" : "",
                  color: state.tab === "Summary" ? "white" : "",
                  fontSize: "1rem",
                  fontWeight: 600,
                  height: "3.5rem",
                  width: "14rem",
                }}
                value="Summary"
                id="navlink_Summary_Tab"
              >
                Pipeline Sufficiency
              </ToggleButton>
              <ToggleButton
                style={{
                  background: state.tab === "Assumptions" ? "#4472C4" : "",
                  color: state.tab === "Assumptions" ? "white" : "",
                  fontSize: "1rem",
                  fontWeight: 600,
                  height: "3.5rem",
                  width: "14rem",
                }}
                value="Assumptions"
                id="navlink_Assumptions_Tab"
              >
                Assumptions
              </ToggleButton>
            </ToggleButtonGroup>
          </Paper>
        </Grid>
      )}

      {/* Assumptions Tab Content */}
      {props.funnelFilters !== "" && state.tab === "Assumptions" && (
        <ErrorBoundary>
          <AssumptionsSection
            assumptionsData={props.AssumptionsData}
            loading={state.loading}
            onSaveAssumptions={props.updateAssumptionsData}
           
          />
        </ErrorBoundary>
      )}

      {/* Pipeline Sufficiency Tab Content */}
      {props.funnelFilters !== "" && state.tab === "Summary" && (
        <ErrorBoundary>
          <PipelineSufficiencySection
            pipelineData={props.NewQualifiedPipelineData}
            loading={state.loading}
             handleChangeLocation={handleChangeLocation}
          />
        </ErrorBoundary>
      )}



             {state.location === "drilldownOnGraph" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={'Open Pipeline'}
              back={handleChangeLocationBack}
              filters={state.filtersForDrilldown}
            >
             
              <DrilldownBody body={props.NewQualifiedPipelineDrilldownData} 
                 company={props.company} 
                handleSecondLevelDrilldown={handleSecondLevelDrilldown}
                 />  
            </SingleLevelDrilldown>
          </Grid>
        )}
         {state.secondLevelLocation === "drilldownOppId" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={"Opportunity Change Events"}
              back={handleChangeLocationBack}
              stepBack={stepBack}
              filters={[]}
            >
              <ExpectedAcvPage body={props.ExpectedAcvData} />
            </SingleLevelDrilldown>
          </Grid>
        )} 

    </Grid>
  );
};


 
// Redux mapStateToProps
const mapStateToProps = (state) => {
  const {
    user,
    NewQualifiedPipelineData,
    drilldownOnGraphData,
    ExpectedAcvData,
    buildingPipelineData,
    AssumptionsData,
    funnelFilters,
  } = state.app;

  return {
    company: user.company,
    NewQualifiedPipelineData,
    AssumptionsData,
    NewQualifiedPipelineDrilldownData: drilldownOnGraphData,
    ExpectedAcvData,
    buildingPipelineData,
    funnelFilters,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
};

// Redux mapDispatchToProps
const mapDispatchToProps = (dispatch) => ({
  getFunnelFilters: () => {
    dispatch({ type: "get_funnel_filters_request" });
    appService.getPGASFilters().then(
      (json) => {
        dispatch({ type: "get_funnel_filters_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_funnel_filters_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_funnel_filters_failure", error });
      }
    );
  },

  clearDrilldownData: () => {
    dispatch({ type: "clear_NewQualifiedPipeline_drilldown_data" });
  },

  getPipelineMixAnalysisDatav2: (filters = []) => {
    dispatch({ type: "get_Assumptions_data_request" });
    dispatch({ type: "current_selected_filters", filters });
    appService.getAssumptionsData(filters).then(
      (json) => {
        dispatch({
          type: "get_Assumptions_data_success",
          json,
        });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_Assumptions_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({
            type: "get_Assumptions_data_failure",
            error,
          });
      }
    );
  },

  getNewQualifiedPipelineDrilldownData: (filters) => {
    dispatch({ type: "get_NewQualifiedPipeline_drilldown_data_request" });
    appService.getNewQualifiedPipelineDrilldownData(filters).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].sort((a, b) =>
          a.acvAtStage > b.acvAtStage ? -1 : 1
        );
        tempOpportunities = tempOpportunities.map((item, index) => ({
          ...item,
          OppNo: index + 1,
        }));

        const updatedJson = {
          ...json,
          message: {
            ...json.message,
            columns: json.message.columns,
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
          },
        };

        dispatch({
          type: "get_NewQualifiedPipeline_drilldown_data_success",
          json: updatedJson,
        });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_NewQualifiedPipeline_drilldown_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({
            type: "get_NewQualifiedPipeline_drilldown_data_failure",
            error,
          });
      }
    );
  },

  getNewQualifiedPipelineData: (filters) => {
    dispatch({ type: "get_NewQualifiedPipeline_data_request" });
    appService.getPGSAData(filters).then(
      (json) => {
        dispatch({ type: "get_NewQualifiedPipeline_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_NewQualifiedPipeline_data_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_NewQualifiedPipeline_data_failure", error });
      }
    );
  },

  getOpenOppData: (oppId) => {
    dispatch({ type: "get_expectedAcv_drilldown_data_request" });
    appService.getWaterfallOppData(oppId).then(
      (json) => {
        dispatch({ type: "get_expectedAcv_drilldown_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_expectedAcv_drilldown_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({ type: "get_expectedAcv_drilldown_data_failure", error });
      }
    );
  },

  clearExpectedAcvData: () => {
    dispatch({ type: "clear_expected_acv_data" });
  },

     getContactDrilldownData: (filters) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getPGSAData(filters).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].sort((a, b) =>
          a.acvAtStage > b.acvAtStage ? -1 : 1
        );
        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json = {
          ...json,
          message: {
            ...json.message,
            columns: json.message.columns,
            count_acv: json.message.opportunities[0],
            opportunities: tempOpportunities,
          },
        };

        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },

  updateAssumptionsData: (data) => {
    dispatch({ type: "update_Assumptions_data_request" });
    
    appService.updateAssumptionsData(data).then(
      (json) => {
        dispatch({
          type: "update_Assumptions_data_success",
          json,
        });
        dispatch({ type: "get_Assumptions_data_request" });
        // Refresh the data after successful update
        appService.getAssumptionsData([]).then(
          (refreshJson) => {
            dispatch({
              type: "get_Assumptions_data_success",
              json: refreshJson,
            });
          }
        );
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "update_Assumptions_data_failure",
            error: "Something went wrong updating assumptions",
          });
        else
          dispatch({
            type: "update_Assumptions_data_failure",
            error,
          });
      }
    );
  },
});

// Connect component to Redux
const connectedPGSA = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PSCA));

export default connectedPGSA;